import { getAWSUrl } from "../api/core";
import { UserStore } from "../store/store";
import InPlayer from "../backend/inplayer";
import Global from "../../global";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import { parse } from "tinyduration";

function arrayExists(name, arr) {
  return arr.some(function (el) {
    return el.videoId === name;
  });
}

export const favourites = (
  event,
  data,
  type,
  favourite = getLocalFavourites()
) => {
  event.preventDefault();

  let arr = favourite;
  let date = new Date();
  let cdate = date.toDateString();
  let obj = {
    title: "",
    type: type,
    videoId: "",
    description: "",
    pageType: "",
    imageUrl: "",
    urlName: "",
    date: "",
  };

  if (type === "page") {
    obj = {
      title: data.displayName,
      type: type,
      videoId: data._id,
      pageType: data.pageType,
      imageUrl: getAWSUrl() + data.landscapeThumbnail.imagekey,
      urlName: data.urlName,
      date: cdate,
    };
  } else {
    if (Global.VCMS === "YouTube") {
      obj = {
        title: data.snippet.title,
        type: type,
        videoId: data.contentDetails.videoId,
        pageType: "video",
        imageUrl: data.snippet.thumbnails.medium,
        urlName: "",
        date: cdate,
      };
    } else {
      obj = {
        title: data.title,
        type: type,
        videoId: data.mediaid,
        pageType: "video",
        imageUrl:
          `https://cdn.jwplayer.com/v2/media/` +
          data.mediaid +
          `/poster.jpg?width=480`,
        urlName: "",
        date: cdate,
      };
    }
  }
  if (!arrayExists(type === "page" ? data._id : data.mediaid, arr)) {
    arr.push(obj);
    localStorage.setItem("favourites", JSON.stringify(arr));
    UserStore.update(updateFav);
  } else {
    let index = arr.findIndex(
      (x) => x.videoId === (type === "page" ? data._id : data.mediaid)
    );
    arr.splice(index, 1);
    localStorage.setItem("favourites", JSON.stringify(arr));
    UserStore.update(updateFav);
  }

  InPlayer.Account.updateAccount({
    metadata: { favourites: JSON.stringify(arr) },
  }).then((data) => {});
};

export const newFavourites = (
  event,
  data,
  type,
  favourite = getLocalFavourites()
) => {
  event.preventDefault();
  let arr = favourite;
  let index = arr.findIndex((x) => x.videoId === data.videoId);
  arr.splice(index, 1);
  localStorage.setItem("favourites", JSON.stringify(arr));
  UserStore.update(updateFav);

  InPlayer.Account.updateAccount({
    metadata: { favourites: JSON.stringify(arr) },
  }).then((data) => {});
};

export const deleteHistory = (event, item, history = getLocalHistory()) => {
  event.preventDefault();
  let arr = history;
  let index = arr.findIndex((x) => x.video_id === item.mediaid);
  arr.splice(index, 1);
  localStorage.setItem("video_list", JSON.stringify(arr));
  UserStore.update(updateHistory);

  InPlayer.Account.updateAccount({
    metadata: { watchHistory: JSON.stringify(arr) },
  }).then((data) => {});
};

export const getLocalFavourites = () => {
  let obj = localStorage.getItem("favourites");
  let arr = JSON.parse(obj);
  return arr;
};
export const getLocalHistory = () => {
  let obj = localStorage.getItem("video_list");
  let arr = JSON.parse(obj);
  return arr;
};

export const getSettings = () => {
  let obj = localStorage.getItem("user_settings");
  let arr = JSON.parse(obj);
  return arr;
};

function updateFav(s) {
  let obj = getLocalFavourites();
  UserStore.update((s) => {
    s.user.FAVOURITES = obj;
  });
}

export const favourited = (name, arr) => {
  return arr.some(function (el) {
    return el.videoId === name;
  });
};

export const watchHistory = (
  second,
  videoId,
  history = getLocalHistory(),
  watchHistory = Global.RPB,
  subscription = Global.SUBSCRIPTION,
  login = Global.LOGIN
) => {
  if (watchHistory) {
    if (second !== null) {
      const arr = history;
      const objIndex = history.findIndex((obj) => obj.video_id === videoId);
      if (objIndex > -1) {
        const newarr = [...arr];
        newarr[objIndex] = second;
        localStorage.setItem("video_list", JSON.stringify(newarr));
        UserStore.update(updateHistory);
        if ((login || subscription) && InPlayer.Account.isAuthenticated()) {
          InPlayer.Account.updateAccount({
            metadata: { watchHistory: JSON.stringify(newarr) },
          }).then((data) => {});
        }
      }
      if (objIndex === -1) {
        const newarr = [...arr];
        newarr.push(second);
        localStorage.setItem("video_list", JSON.stringify(newarr));
        UserStore.update(updateHistory);
        if ((login || subscription) && InPlayer.Account.isAuthenticated()) {
          InPlayer.Account.updateAccount({
            metadata: { watchHistory: JSON.stringify(newarr) },
          }).then((data) => {});
        }
      }
    }
  }
};
export const saveSetting = (setting) => {
  if (
    (Global.LOGIN || Global.SUBSCRIPTION) &&
    InPlayer.Account.isAuthenticated()
  ) {
    InPlayer.Account.updateAccount({
      metadata: { settings: JSON.stringify(setting) },
    }).then((data) => {});
  }
};

export const clearWatchHistory = (watchhistory, event) => {
  event.preventDefault();
  toastr.clear();
  if (watchhistory.length > 0) {
    localStorage.setItem("video_list", JSON.stringify([]));
    UserStore.update(updateHistory);
    InPlayer.Account.updateAccount({
      metadata: { watchHistory: JSON.stringify([]) },
    }).then((data) => {});

    toastr.info("Watch History Cleared Successfully", "Success");
  } else {
    toastr.info("No Video in WatchHistory to Clear", "Empty Watch History");
  }
};

export const clearFavourites = (favourites, event) => {
  event.preventDefault();
  toastr.clear();
  if (favourites.length > 0) {
    localStorage.setItem("favourites", JSON.stringify([]));
    UserStore.update(updateFav);
    InPlayer.Account.updateAccount({
      metadata: { favourites: JSON.stringify([]) },
    }).then((data) => {});
    toastr.info("Favourites Cleared Successfully", "Success");
  } else {
    toastr.info("No Video in Favourites to Clear", "Empty Favourite List");
  }
};

function updateHistory(s) {
  let obj = getLocalHistory();
  UserStore.update((s) => {
    s.user.WATCHHISTORY = obj;
  });
}

export const setSetting = (setting) => {
  setting
    ? localStorage.setItem("settings", JSON.stringify(setting))
    : localStorage.setItem("settings", JSON.stringify({}));
};
export const intializeSetting = () => {
  let obj = {
    DARK_MODE: Global.DARK,
    LAN: "en-us",
    ES_COOKIE: false,
    AD_COOKIE: false,
    PR_COOKIE: false,
    COUNTRY: "",
  };
  return obj;
};
export function isEmpty(obj) {
  return Object.keys(obj).length === 0;
}

export const getSetting = () => {
  let obj = localStorage.getItem("settings");
  let arr = JSON.parse(obj);
  return arr ? arr : {};
};

export const getPercentage = (video, arr) => {
  const result = arr.filter((item) => item.video_id === video);
  let duration =
    result.length !== 0
      ? isNaN(parseInt(result[0].duration))
        ? 0
        : parseInt(result[0].duration)
      : 0;
  let position =
    result.length !== 0
      ? isNaN(parseInt(result[0].position))
        ? 0
        : parseInt(result[0].position)
      : 0;
  let percentage = (position / duration) * 100;
  return isNaN(parseInt(percentage)) ? 0 : parseInt(percentage);
};

export const getSeasonWatch = (seasonList, history, appId) => {
  let result = history.filter(function (o1) {
    // filter out (!) items in result2
    return seasonList.some(function (o2) {
      return o1.list_id === o2.itemid; // assumes unique id
    });
  });

  let final = result.sort(function (a, b) {
    // Turn your strings into dates, and then subtract them
    // to get a value that is either negative, positive, or zero.
    return new Date(b.date) - new Date(a.date);
  });

  let finalResult = "";
  let videoId = "";
  if (final.length !== 0) {
    if (final[0].list_id && final[0].limit) {
      finalResult =
        "/" +
        appId +
        "/episode/" +
        final[0].list_id +
        "/watch/" +
        final[0].video_id +
        "/" +
        final[0].limit;
      videoId = final[0].video_id;
    }
    if (final[0].list_id && final[0].limit === "") {
      finalResult =
        "/" +
        appId +
        "/episode/" +
        final[0].list_id +
        "/watch/" +
        final[0].video_id +
        "/1";
      videoId = final[0].video_id;
    }
  }

  return { finalResult, videoId };
};

export const videoTitle = (name, arr) => {
  let newarr = arr.filter(function (el) {
    return el.video_id === name;
  });

  if (newarr.length > 0) {
    return newarr[0].title;
  } else {
    return "";
  }
};

export const sortArray = (arr) => {
  let final = arr.slice().sort(function (a, b) {
    // Turn your strings into dates, and then subtract them
    // to get a value that is either negative, positive, or zero.
    return new Date(b.date) - new Date(a.date);
  });
  return final;
};
export const limitArray = (arr, limit, start) => {
  return arr.slice(start, limit);
};
export const formatDate = (date) => {
  let d = new Date(date);
  const month = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "June",
    "July",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];
  let day = d.getDate();
  let year = " " + d.getFullYear();
  let mon = " " + month[d.getMonth()];
  return day + mon + year;
};
export const getTimeFromISODateString = (isoDateString) => {
  const date = parse(isoDateString);
  let hrs = date.hours;
  let mins = date.minutes;
  const second = date.seconds;

  if (hrs) {
    return { hrs, mins, second };
  } else {
    hrs = 0;
    return { hrs, mins, second };
  }
};
export const formatTimeDate = (date) => {
  let d = date;
  const month = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "June",
    "July",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];
  let day = d.getDate();
  let year = " " + d.getFullYear();
  let mon = " " + month[d.getMonth()];

  return day + mon + year;
};

export const formatTimeStamp = (timestamp) => {
  let date = new Date(timestamp * 1000);
  return formatTimeDate(date);
};

export const arrayWithProgress = (arr, limit, start, flag) => {
  let newarr = [];
  let sortedArray = sortArray(arr);
  let limitedArray = limitArray(sortedArray, limit, start);
  limitedArray.forEach((element) => {
    let duration = element.duration ? parseInt(element.duration) : 0;
    let position = element.duration ? parseFloat(element.position) : 0;
    let percentage = (position / duration) * 100;
    let percent = isNaN(percentage) ? 0 : percentage;

    const obj = {
      duration: element.duration,
      position: element.position,
      video_id: element.video_id,
      type: element.type,
      list_id: element.list_id,
      date: element.date,
      limit: element.limit,
      title: element.title,
      progress: percent,
    };
    if (flag) {
      newarr.push(obj);
    } else {
      if (percent > 3 && percent <= 96) {
        newarr.push(obj);
      } else {
      }
    }
  });
  return newarr;
};

export const changeName = (OEM, name) => {
  if (OEM === "Inplayer") {
    InPlayer.Account.updateAccount({
      fullName: name,
    }).then((data) => {
      UserStore.update((s) => {
        s.user.NAME = name;
      });
      toastr.info("Full Name Updated Successfully", "Success");
    });
  }
};

export const changeCountry = (OEM, name) => {
  if (OEM === "Inplayer") {
    InPlayer.Account.updateAccount({
      fullName: name,
    }).then((data) => {
      UserStore.update((s) => {
        s.user.NAME = name;
      });
      toastr.info("Full Name Updated Successfully", "Success");
    });
  }
};

export const changePWD = (OEM, oldpwd, newpwd, confirmpwd) => {
  if (OEM === "Inplayer") {
    InPlayer.Account.changePassword({
      oldPassword: oldpwd,
      password: newpwd,
      passwordConfirmation: confirmpwd,
    }).then((data) => {
      toastr.info("Full Name Updated Successfully", "Success");
    });
  }
};
export const changePhone = (OEM, name) => {
  if (OEM === "Inplayer") {
    InPlayer.Account.updateAccount({
      fullName: name,
    }).then((data) => {
      UserStore.update((s) => {
        s.user.NAME = name;
      });
      toastr.info("Full Name Updated Successfully", "Success");
    });
  }
};

export const defaultCard = async () => {
  const rest = await InPlayer.Payment.getDefaultCreditCard()
    .then((data) => {
      return data;
    })
    .catch((error) => {
      return error;
    });

  return rest;
};

export const addForwardButton = (player) => {
  const playerContainer = player.getContainer();
  const buttonContainer = playerContainer.querySelector(".jw-button-container");
  // Forward 10 seconds
  const rewindContainer = playerContainer.querySelector(
    ".jw-display-icon-rewind"
  );
  const forwardContainer = rewindContainer.cloneNode(true);
  const forwardDisplayButton =
    forwardContainer.querySelector(".jw-icon-rewind");
  forwardDisplayButton.style.transform = "scaleX(-1)";
  forwardDisplayButton.ariaLabel = "Forward 10 Seconds";
  const nextContainer = playerContainer.querySelector(".jw-display-icon-next");
  nextContainer.parentNode.insertBefore(forwardContainer, nextContainer);

  // control bar icon
  playerContainer.querySelector(".jw-display-icon-next").style.display = "none"; // hide next button
  const rewindControlBarButton =
    buttonContainer.querySelector(".jw-icon-rewind");
  const forwardControlBarButton = rewindControlBarButton.cloneNode(true);
  forwardControlBarButton.style.transform = "scaleX(-1)";
  forwardControlBarButton.ariaLabel = "Forward 10 Seconds";
  rewindControlBarButton.parentNode.insertBefore(
    forwardControlBarButton,
    rewindControlBarButton.nextElementSibling
  );

  // add onclick handlers
  [forwardDisplayButton, forwardControlBarButton].forEach((button) => {
    button.onclick = () => {
      player.seek(player.getPosition() + 10);
    };
  });
};

export function padTo2Digits(num) {
  return num.toString().padStart(2, "0");
}

export function formatUTCDate(dates) {
  let date = new Date(dates);
  return [
    date.getFullYear(),
    padTo2Digits(date.getMonth() + 1),
    padTo2Digits(date.getDate()),
  ].join("-");
}

export function secondsToISO8601(input, timeOnly) {
  if (!input) {
    return "";
  }

  const date = new Date(input ? input * 1000 : 0);
  const hours = date.getUTCHours();
  const minutes = date.getUTCMinutes();
  const seconds = date.getUTCSeconds();

  if (!timeOnly) {
    return date.toISOString();
  }

  let isoString = "PT";
  if (hours > 0) isoString += hours + "H";
  if (minutes > 0) isoString += minutes + "M";
  if (seconds > 0) isoString += seconds + "S";

  return isoString;
}

export const is12HourClock = () => {
  const date = new Date(Date.UTC(2022, 6, 20, 18, 0, 0));
  return /am|pm/.test(date.toLocaleTimeString());
};

export const truncate = (str, maxlength) => {
  if (str && maxlength) {
    return str.length > maxlength ? str.slice(0, maxlength - 1) + "…" : str;
  } else {
    return str;
  }
};

export const truncated = (str, maxlength) => {
  if (str && maxlength) {
    return str.length > maxlength ? str.slice(0, maxlength - 1) + "…" : str;
  } else {
    return str;
  }
};

export const resizeFrame = (object) => {
  object.style.height =
    object.contentWindow.document.documentElement.scrollHeight + "px";
};
